module.exports = __webpack_public_path__ + "robotomono-regular-webfont-51e9ccf8c829f4894a7e5a0883e864fc.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto-mono/robotomono-regular-webfont.svg
// module id = 879
// module chunks = 88